import { render, staticRenderFns } from "./case-copy.vue?vue&type=template&id=215eed80&scoped=true&"
import script from "./case-copy.vue?vue&type=script&lang=js&"
export * from "./case-copy.vue?vue&type=script&lang=js&"
import style0 from "./case-copy.vue?vue&type=style&index=0&id=215eed80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215eed80",
  null
  
)

export default component.exports